import { type TypedUseSelectorHook, useSelector } from 'react-redux';

import type { RootState } from '@app/types';

export default useSelector as TypedUseSelectorHook<RootState>;
